var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCertificateBg = function SvgCertificateBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "115px",
    viewBox: "0 0 360 115",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 1.59161573e-12,
    width: 360,
    height: 115,
    rx: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.0070257%",
    y1: "47.2680769%",
    x2: "44.806494%",
    y2: "52.9636329%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A3B8",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A3B8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consult-List",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Consult-List-/-Details-/-Pickup",
    transform: "translate(-730.000000, -521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(330.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MC",
    transform: "translate(400.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-Copy-2",
    fill: "#2FC2D6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,-4.29878355e-12 L360,115 L-1.94626923e-13,115 L-1.94626923e-13,-4.29878355e-12 L360,-4.29878355e-12 Z M359.987984,-5.71986902e-12 L261.718393,0.0605818162 L93.7016646,114.918052 L208.396602,114.985769 L359.987984,11.3567858 L359.987984,-5.71986902e-12 Z M360,21.1744402 L222.850333,114.93096 L261.095071,114.944582 L359.716011,47.5265836 L360,21.1744402 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)",
    opacity: 0.3,
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCertificateBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/certificate-bg.2333bc95.svg";
export { ForwardRef as ReactComponent };